import { render, staticRenderFns } from "./scrolled-table.vue?vue&type=template&id=7b31867d&scoped=true&"
import script from "./scrolled-table.vue?vue&type=script&lang=js&"
export * from "./scrolled-table.vue?vue&type=script&lang=js&"
import style0 from "./scrolled-table.vue?vue&type=style&index=0&id=7b31867d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b31867d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b31867d')) {
      api.createRecord('7b31867d', component.options)
    } else {
      api.reload('7b31867d', component.options)
    }
    module.hot.accept("./scrolled-table.vue?vue&type=template&id=7b31867d&scoped=true&", function () {
      api.rerender('7b31867d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scrolled-table.vue"
export default component.exports